import { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";

const stats = [
  { value: 420, suffix: "+", label: "Businesses Guided", testid: "stat-businesses-guided" },
  { value: 750, suffix: "+", label: "Projects Completed", testid: "stat-projects-completed" },
  { value: 8, suffix: "", label: "Years in Business", testid: "stat-years-in-business" },
];

const Counter = ({ value, active }) => {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!active) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [active, value]);

  return <span>{display}</span>;
};

export default function Stats() {
  const [active, setActive] = useState(false);

  return (
    <motion.div
      data-testid="stats-section"
      className="border-b border-gold/25 pb-14"
      onViewportEnter={() => setActive(true)}
      viewport={{ once: true, margin: "-60px" }}
    >
      <div className="grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-0">
        {stats.map((s, i) => (
          <motion.div
            key={s.testid}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className={`flex flex-col items-start px-0 sm:px-10 ${
              i > 0 ? "sm:border-l sm:border-gold/25" : "sm:pl-0"
            }`}
            data-testid={s.testid}
          >
            <p className="font-serif text-6xl font-medium leading-none tracking-tight text-cream lg:text-7xl">
              <Counter value={s.value} active={active} />
              <span className="italic text-gold">{s.suffix}</span>
            </p>
            <p className="mt-4 font-sans text-xs font-semibold uppercase tracking-[0.24em] text-cream/60">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
